import { ConversationTaskView } from './conversation-tasks.component';
import { PlaceEnrichmentTaskView } from './place-enrichment-task.component';

/** UI-only sample data; never written to conversation history. */
export function conversationTaskPreview(): ConversationTaskView[] {
  const enrichment: PlaceEnrichmentTaskView = {
    id: 'preview-places', title: 'Enrich 100 places', agentName: 'Scout', status: 'running',
    progress: 'Finding missing contact details and opening hours.',
    enrichment: { completed: 38, total: 100 },
    subAgents: [
      { name: 'Agent 1', activity: 'Finding phone numbers for places in Oak Lawn' },
      { name: 'Agent 2', activity: 'Checking opening hours for places in Alsip' },
      { name: 'Agent 3', activity: 'Finding websites for places in Burbank' },
      { name: 'Agent 4', activity: 'Verifying addresses for places in Chicago Ridge' },
    ],
  };
  return [enrichment,
    { id: 'preview-research', title: 'Research the Oak Lawn market', agentName: 'Atlas', status: 'running',
      progress: 'Comparing local competitors and identifying service gaps.', subAgents: [
        { name: 'Agent 1', activity: 'Researching local waste collection providers' },
        { name: 'Agent 2', activity: 'Comparing published services and pricing' },
        { name: 'Agent 3', activity: 'Reviewing customer feedback for unmet needs' },
      ] },
    { id: 'preview-report', title: 'Yesterday’s lead summary', agentName: 'BRee', status: 'completed',
      progress: 'Your lead summary is ready.', result: '12 new leads: 4 in Oak Lawn, 5 in Alsip and 3 in Burbank.' },
    { id: 'preview-contact', title: 'Verify lead contacts', agentName: 'Scout', status: 'failed',
      progress: 'Contact lookup unavailable', error: 'The contact service could not be reached.' },
  ];
}
